import React from 'react'
import { ImageText } from './components/imagetext';
import { Container } from './components/container';
import { Footer } from './components/footer';
import { Problem } from './problem';
import { Solution  } from './solution';
import { Demo } from './demo';
import { IState } from '../chatbot/api/llmapi';
import { Util } from '../fasades/util';
import './home.css';

interface Props
{
    state : IState;
}

export class Home extends React.Component<Props>
{
    render() {
        return (
            <>
            <title>TigerCity.ai - AI Agents that learn via Continuous Learning</title>
            <meta
                    name="description"
                    content="Norwegian AI platform for continuous agent learning. Build adaptive AI\
                             agents through simplified LLM fine-tuning—no ML expertise required."
            />
            <link rel="canonical" href={Util.getTigerCityUrl()}/>

            <div className="home">
                <div>
                    <ImageText/>
                </div>
                <Container>
                    <Problem/>
                </Container>
                <Container>
                    <Solution/>
                </Container>
                <Container>
                    <Demo playgroundRunning={ this.props.state.playgroundRunning }/>
                </Container>
                <Footer/>
           </div>
           </>
        )
    }
}

